import { ArrowForwardIcon } from "@chakra-ui/icons";
import {
  Box,
  Flex,
  Input,
  InputGroup,
  InputRightElement,
} from "@chakra-ui/react";
import React, { useState } from "react";
import { MdExpandLess, MdExpandMore } from "react-icons/md";

const getChildSum = (item) => {
  if (!item.children) return 0;

  return Object.values(item.children).reduce(
    (acc, child) => acc + (child.value ? Number(child.value) : 0),
    0
  );
};

export const RecursiveInput = ({ data, setData, enableEdit }) => {
  const initialExpandedState = {};

  // Function to set all keys in initialExpandedState to true
  const setAllKeysToTrue = (data, path = []) => {
    for (const element in data) {
      const currentPath = [...path, element].join(".");
      initialExpandedState[currentPath] = true;

      if (data[element].hasChildren) {
        setAllKeysToTrue(data[element].children, [...path, element]);
      }
    }
  };
  setAllKeysToTrue(data);

  const order = {
    Ore: 1,
    Reductant: 2,
    Flux: 3,
  };
  const [expanded, setExpanded] = useState(initialExpandedState);

  const handleChange = (path, value) => {
    // console.log(path, value);
    value = isNaN(parseFloat(value)) ? null : parseFloat(value);
    setData((prevData) => {
      // console.log(prevData);
      const newData = { ...prevData };

      let currentLevel = newData;

      // Traverse the path to the last level
      for (let i = 0; i < path.length - 1; i++) {
        currentLevel = currentLevel[path[i]].children;
      }

      // Update the value at the last level
      currentLevel[path[path.length - 1]].value = value;
      // console.log(newData);
      return newData;
    });
  };

  const toggleExpand = (path) => {
    setExpanded((prevExpanded) => {
      const newExpanded = { ...prevExpanded };
      const key = path.join(".");
      newExpanded[key] = !newExpanded[key];
      return newExpanded;
    });
  };
  console.log(Object.entries(data));
  const renderChildren = (children, path, applyPercentConstraint) => {
    // console.log(applyPercentConstraint);
    const key = path.join(".");
    return (
      <Box ml={20} mt={2} display="flex" flexDirection="column" flexWrap="wrap">
        {expanded[key] &&
          Object.entries(children)
            ?.sort()
            ?.map(([childName, child]) => (
              <Box key={childName} mt="10px" ml={4}>
                <Flex h="30px">
                  <Flex
                    h="100%"
                    color="white"
                    // w="120px"
                    minW={"120px"}
                    paddingX={"15px"}
                    bg="gray.600"
                    textAlign="center"
                    className="text-center items-center justify-center"
                    fontSize="12px"
                  >
                    {childName}
                    {child.hasChildren && (
                      <span
                        style={{
                          marginLeft: "6px",
                          fontWeight: "normal",
                          fontSize: "11px",
                        }}
                      >
                        (Total: {getChildSum(child)})
                      </span>
                    )}
                  </Flex>
                  <InputGroup
                    maxW={`${
                      applyPercentConstraint === false ? "50px" : "180px"
                    }`}
                  >
                    {applyPercentConstraint === true && (
                      <Input
                        h="100%"
                        size="sm"
                        borderRadius="2"
                        type="number"
                        disabled={!enableEdit}
                        value={child.value != null ? child.value : ""}
                        onChange={(e) =>
                          handleChange([...path, childName], e.target.value)
                        }
                        onKeyDown={(e) => {
                          if (e.key === "ArrowUp" || e.key === "ArrowDown") {
                            e.preventDefault();
                          }
                        }}
                        onWheel={(e) => e.target.blur()}
                        onScroll={(e) => e.target.blur()}
                      />
                    )}
                    {child.hasChildren && (
                      <InputRightElement
                        cursor="pointer"
                        bg="gray.100"
                        h="100%"
                        onClick={() => toggleExpand([...path, childName])}
                      >
                        {expanded[[...path, childName].join(".")] ? (
                          <MdExpandLess />
                        ) : (
                          <MdExpandMore />
                        )}
                      </InputRightElement>
                    )}
                  </InputGroup>
                </Flex>
                {child.hasChildren &&
                  renderChildren(
                    child.children,
                    [...path, childName],
                    child.applyPercentConstraint
                  )}
              </Box>
            ))}
      </Box>
    );
  };

  return (
    <Box mt={2} mb={4}>
      <Box display="flex" flexDirection="column" flexWrap="wrap">
        {Object.entries(data)
          ?.sort((a, b) => order[a[0]] - order[b[0]])
          ?.map(([itemName, item]) => (
            <Box key={itemName} ml={4} mt="10px">
              <Flex h="30px">
                <Flex className="flex items-center">
                  <ArrowForwardIcon fontSize={"2xl"} />
                </Flex>
                <Flex
                  h="100%"
                  color="white"
                  w="120px"
                  minW={"120px"}
                  bg="gray.600"
                  textAlign="center"
                  className="text-center items-center justify-center"
                  fontSize="12px"
                >
                  {itemName}
                  {item.hasChildren && (
                    <span
                      style={{
                        marginLeft: "6px",
                        fontWeight: "normal",
                        fontSize: "11px",
                      }}
                    >
                      (Total: {getChildSum(item)})
                    </span>
                  )}
                </Flex>
                <InputGroup maxW="50px">
                  {/* <Input
                  h="100%"
                  size="sm"
                  borderRadius="2"
                  type="number"
                  disabled={!enableEdit}
                  value={item.value != null ? item.value : ""}
                  onChange={(e) => handleChange([itemName], e.target.value)}
                /> */}
                  {item.hasChildren && (
                    <InputRightElement
                      bg="gray.100"
                      cursor="pointer"
                      h="100%"
                      onClick={() => toggleExpand([itemName])}
                    >
                      {expanded[itemName] ? <MdExpandLess /> : <MdExpandMore />}
                    </InputRightElement>
                  )}
                </InputGroup>
              </Flex>
              {item.hasChildren &&
                renderChildren(
                  item.children,
                  [itemName],
                  item.applyPercentConstraint
                )}
            </Box>
          ))}
      </Box>
    </Box>
  );
};
